require.register("ffss/Application", function(exports, require, module){
  $0
  
});

